import { render, staticRenderFns } from "./seats.vue?vue&type=template&id=d97c1120&"
import script from "./seats.vue?vue&type=script&lang=js&"
export * from "./seats.vue?vue&type=script&lang=js&"
import style0 from "./seats.vue?vue&type=style&index=0&id=d97c1120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports